module.exports = __webpack_public_path__ + "static/contact-12c421148ed57dfe51c88ed990af8b38.jpg";